import { KzIconElement } from '@kaizenplatform/kaizen-icon-elements';
import styled from '@emotion/styled';
import { createElement } from 'react';
import { ColorProperty } from 'csstype';

interface Props {
  className?: string;
  size?: number;
  color?: ColorProperty;
}

const Wrapper = styled('span')({
  lineHeight: 0,
});

export const createIconElement = (IconCustomElement: typeof KzIconElement) => {
  return ({ className, size, color }: Props) => {
    const IconElement = createElement(IconCustomElement.is, {
      size: size,
      color: color,
    });

    return <Wrapper className={className}>{IconElement}</Wrapper>;
  };
};
